// Translations for PROBUILD MARKET

export const translations = {
  en: {
    // Navigation
    nav: {
      solutions: 'Solutions',
      materials: 'Materials',
      about: 'About',
      partners: 'Partners',
      contact: 'Contact',
      getQuote: 'Get Quote',
    },
    
    // Hero
    hero: {
      title: 'Building the Future.',
      titleTogether: 'Together.',
      subtitle: 'Premium international platform for construction materials and engineering solutions.',
      exploreSolutions: 'Explore Solutions',
    },
    
    // About
    about: {
      title: 'Vision & Mission',
      description: 'Creating an intelligent and transparent supply system for construction projects — from wholesale purchases to retail distribution, connecting suppliers, architects, and contractors in a unified digital space.',
      missionTitle: 'PROBUILD MARKET LIMITED is a premium international platform for construction materials and engineering solutions',
      missionText: 'We unite manufacturers, distributors, and construction companies in one ecosystem. Our main idea is to simplify and accelerate the supply of construction materials from different countries to the EU, maintaining transparency, quality, and technological efficiency.',
      values: {
        transparency: {
          title: 'Transparency & Trust',
          description: 'Open pricing, clear processes, and reliable partnerships built on mutual respect.',
        },
        technology: {
          title: 'Technology-Driven',
          description: 'Digital platform with online supply control and smart building solutions.',
        },
        minimalism: {
          title: 'Minimalism & Precision',
          description: 'Architectural aesthetics in every element, clean design meets functionality.',
        },
        quality: {
          title: 'European Quality',
          description: 'Partner network of certified manufacturers ensuring highest standards.',
        },
      },
    },
    
    // Solutions
    solutions: {
      title: 'Solutions & Services',
      subtitle: 'Comprehensive construction supply chain solutions designed for modern building projects.',
      learnMore: 'Learn More',
      importExport: {
        title: 'Import & Export',
        subtitle: 'Construction Materials',
        description: 'Concrete, glass, metal structures, insulation, and engineering elements from certified manufacturers across Europe.',
        features: {
          certification: 'Quality Certification',
          compliance: 'EU Compliance',
          bulk: 'Bulk Orders',
        },
      },
      distribution: {
        title: 'Distribution',
        subtitle: 'Electrical & Plumbing',
        description: 'Lighting, cables, ventilation, heating systems with comprehensive logistics and delivery solutions.',
        features: {
          delivery: 'Fast Delivery',
          inventory: 'Inventory Management',
          support: 'Technical Support',
        },
      },
      b2bPlatform: {
        title: 'B2B Platform',
        subtitle: 'Digital Marketplace',
        description: 'Online marketplace with catalog, pricing, logistics, and application management for seamless operations.',
        features: {
          pricing: 'Real-time Pricing',
          tracking: 'Order Tracking',
          documentation: 'Digital Documentation',
        },
      },
      logistics: {
        title: 'Logistics Management',
        subtitle: 'Complete Supply Chain',
        description: 'Customs, certification, transportation, and insurance management for streamlined operations.',
        features: {
          customs: 'Customs Clearance',
          insurance: 'Insurance Coverage',
          tracking: 'End-to-end Tracking',
        },
      },
      smartBuilding: {
        title: 'Smart Building Solutions',
        subtitle: 'AI & Data Analytics',
        description: 'Supply analytics, budget optimization, and sustainable construction solutions powered by artificial intelligence.',
        features: {
          analytics: 'Predictive Analytics',
          optimization: 'Cost Optimization',
          sustainability: 'Sustainability Metrics',
        },
      },
    },
    
    // Materials
    materials: {
      title: 'Materials Catalog',
      subtitle: 'Explore our comprehensive catalog of premium construction materials from certified European manufacturers.',
      searchPlaceholder: 'Search materials...',
      category: 'Category',
      country: 'Country',
      inStockOnly: 'In Stock Only',
      showing: 'Showing',
      of: 'of',
      materials: 'materials',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      requestQuote: 'Request Quote',
      notifyWhenAvailable: 'Notify When Available',
      noMaterialsFound: 'No materials found',
      tryAdjusting: 'Try adjusting your search criteria or filters.',
    },
    
    // Partners
    partners: {
      title: 'Partners & Clients',
      subtitle: 'Trusted by leading construction companies and manufacturers across Europe.',
      certifiedPartners: 'Certified Partners',
      clientTestimonials: 'Client Testimonials',
      stats: {
        projectsCompleted: 'Projects Completed',
        partnerCompanies: 'Partner Companies',
        countriesServed: 'Countries Served',
        materialsCatalog: 'Materials Catalog',
      },
    },
    
    // Contact
    contact: {
      title: 'Start Your Project',
      subtitle: 'Ready to transform your construction project? Get in touch with our experts for personalized solutions.',
      projectInquiryForm: 'Project Inquiry Form',
      formDescription: 'Tell us about your project requirements and we\'ll provide a custom quote.',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      companyName: 'Company Name',
      phoneNumber: 'Phone Number',
      projectType: 'Project Type',
      budgetRange: 'Budget Range',
      projectDetails: 'Project Details',
      selectProjectType: 'Select project type',
      selectBudgetRange: 'Select budget range',
      describeProject: 'Please describe your project requirements, timeline, and any specific materials needed...',
      sendProjectInquiry: 'Send Project Inquiry',
      submitting: 'Submitting...',
      contactInformation: 'Contact Information',
      address: 'Address',
      email: 'Email',
      businessHours: 'Business Hours',
      quickResponseGuarantee: 'Quick Response Guarantee',
      quickResponseText: 'We respond to all project inquiries within 24 hours. For urgent requests, call us directly.',
      ourServices: 'Our Services',
      projectTypes: {
        residential: 'Residential Construction',
        commercial: 'Commercial Building',
        industrial: 'Industrial Facility',
        infrastructure: 'Infrastructure Project',
        renovation: 'Renovation/Retrofit',
        other: 'Other',
      },
      budgetRanges: {
        under50k: 'Under €50,000',
        range50k250k: '€50,000 - €250,000',
        range250k1m: '€250,000 - €1,000,000',
        range1m5m: '€1,000,000 - €5,000,000',
        over5m: 'Over €5,000,000',
      },
      successMessage: 'Thank you! We\'ll contact you within 24 hours.',
      successDescription: 'Your project inquiry has been received successfully.',
    },
    
    // Footer
    footer: {
      description: 'Premium international platform for construction materials and engineering solutions. Connecting manufacturers, distributors, and construction companies across Europe.',
      solutions: {
        title: 'Solutions',
        importExport: 'Import & Export',
        distribution: 'Distribution',
        b2bPlatform: 'B2B Platform',
        logisticsManagement: 'Logistics Management',
        smartBuilding: 'Smart Building Solutions',
      },
      materials: {
        title: 'Materials',
        steelMetal: 'Steel & Metal',
        concreteBlocks: 'Concrete & Blocks',
        insulation: 'Insulation',
        glassFacades: 'Glass & Facades',
        electricalSystems: 'Electrical Systems',
      },
      company: {
        title: 'Company',
        aboutUs: 'About Us',
        ourPartners: 'Our Partners',
        qualityStandards: 'Quality Standards',
        sustainability: 'Sustainability',
        careers: 'Careers',
      },
      support: {
        title: 'Support',
        contactUs: 'Contact Us',
        technicalSupport: 'Technical Support',
        documentation: 'Documentation',
        faq: 'FAQ',
        termsConditions: 'Terms & Conditions',
      },
      copyright: '© 2025 PROBUILD MARKET LIMITED. All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      legalNotice: 'Legal Notice',
      followUs: 'Follow us:',
    },
    
    // Modals
    modals: {
      quote: {
        title: 'Get Instant Quote',
        description: 'Tell us about your construction material needs and receive a detailed quote within hours.',
        cancel: 'Cancel',
        sending: 'Sending...',
        getQuote: 'Get Quote',
        projectTypes: {
          steelMetal: 'Steel & Metal Structures',
          concrete: 'Concrete & Masonry',
          insulation: 'Insulation Materials',
          electrical: 'Electrical Systems',
          plumbing: 'Plumbing & HVAC',
          glass: 'Glass & Facades',
          mixed: 'Mixed Materials Project',
        },
        budgetRanges: {
          under25k: 'Under €25,000',
          range25k100k: '€25,000 - €100,000',
          range100k500k: '€100,000 - €500,000',
          range500k2m: '€500,000 - €2,000,000',
          over2m: 'Over €2,000,000',
        },
        urgency: {
          immediate: 'Immediate (Within 1 week)',
          urgent: 'Urgent (Within 1 month)',
          standard: 'Standard (1-3 months)',
          planning: 'Planning Phase (3+ months)',
        },
        successMessage: 'Quote request sent successfully!',
        successDescription: 'Our team will contact you within 4 hours with a detailed quote.',
      },
      materialQuote: {
        requestQuote: 'Request Quote',
        quantityRequired: 'Quantity Required',
        requiredDeliveryDate: 'Required Delivery Date',
        deliveryAddress: 'Delivery Address',
        specialRequirements: 'Special Requirements',
        units: 'units',
        estimatedTotal: 'Estimated Total',
        finalPriceNote: '*Final price may vary based on current market rates and delivery location',
        successMessage: 'Material quote request sent!',
      },
      demo: {
        title: 'PROBUILD MARKET Platform Demo',
        description: 'Explore our construction materials platform and see how it can transform your building projects.',
        demoSections: 'Demo Sections',
        readyToStart: 'Ready to start?',
        readyDescription: 'Get a personalized demo with our construction materials experts.',
        scheduleLiveDemo: 'Schedule Live Demo',
        overview: {
          title: 'PROBUILD MARKET Overview',
          description: 'See how our platform connects European construction material suppliers with builders',
        },
        materials: {
          title: 'Materials Warehouse',
          description: 'Explore our vast inventory of certified construction materials from 150+ suppliers',
        },
        ordering: {
          title: 'B2B Ordering System',
          description: 'Digital procurement process from quote to delivery with real-time logistics',
        },
        tracking: {
          title: 'Supply Chain Tracking',
          description: 'Monitor materials from European warehouses to your construction site',
        },
      },
    },
    
    // Pages
    pages: {
      importExport: {
        backToHome: 'Back to Home',
        badge: 'Import & Export Solutions',
        title: 'Premium Construction Materials',
        titleFrom: 'From Across Europe',
        description: 'Access certified construction materials from over 150 European manufacturers. We handle everything from sourcing to delivery, ensuring quality and compliance.',
        requestMaterialsQuote: 'Request Materials Quote',
        viewCatalog: 'View Catalog',
        materialCategories: 'Material Categories',
        whyChoose: 'Why Choose Our Import/Export Services',
        ourImportProcess: 'Our Import Process',
        readyToSource: 'Ready to Source Premium Materials?',
        contactExperts: 'Contact our materials experts for customized sourcing solutions.',
        getStartedToday: 'Get Started Today',
      },
    },
    
    // Common
    common: {
      required: 'required',
      selectType: 'Select type',
      selectTimeline: 'Timeline',
      urgency: 'Urgency',
      placeholder: {
        enterFullName: 'Enter your full name',
        enterEmail: 'your.email@company.com',
        enterCompany: 'Your Company Ltd.',
        enterPhone: '+31 XX XXX XXXX',
        enterAddress: 'Complete delivery address including postal code...',
        enterRequirements: 'Any special handling, custom specifications, or delivery instructions...',
        describeRequirements: 'Please describe your specific material requirements, quantities, delivery timeline, and any special specifications...',
      },
    },
  },
  
  fr: {
    // Navigation
    nav: {
      solutions: 'Solutions',
      materials: 'Matériaux',
      about: 'À propos',
      partners: 'Partenaires',
      contact: 'Contact',
      getQuote: 'Obtenir un devis',
    },
    
    // Hero
    hero: {
      title: 'Construire l\'avenir.',
      titleTogether: 'Ensemble.',
      subtitle: 'Plateforme internationale premium pour les matériaux de construction et les solutions d\'ingénierie.',
      exploreSolutions: 'Explorer les solutions',
    },
    
    // About
    about: {
      title: 'Vision et Mission',
      description: 'Création d\'un système d\'approvisionnement intelligent et transparent pour les projets de construction — des achats en gros à la distribution de détail, connectant fournisseurs, architectes et entrepreneurs dans un espace numérique unifié.',
      missionTitle: 'PROBUILD MARKET LIMITED est une plateforme internationale premium pour les matériaux de construction et les solutions d\'ingénierie',
      missionText: 'Nous unissons fabricants, distributeurs et entreprises de construction dans un écosystème unique. Notre idée principale est de simplifier et d\'accélérer l\'approvisionnement en matériaux de construction de différents pays vers l\'UE, en maintenant la transparence, la qualité et l\'efficacité technologique.',
      values: {
        transparency: {
          title: 'Transparence et Confiance',
          description: 'Tarification ouverte, processus clairs et partenariats fiables construits sur le respect mutuel.',
        },
        technology: {
          title: 'Axé sur la Technologie',
          description: 'Plateforme numérique avec contrôle d\'approvisionnement en ligne et solutions de construction intelligentes.',
        },
        minimalism: {
          title: 'Minimalisme et Précision',
          description: 'Esthétique architecturale dans chaque élément, design épuré allié à la fonctionnalité.',
        },
        quality: {
          title: 'Qualité Européenne',
          description: 'Réseau de partenaires de fabricants certifiés garantissant les normes les plus élevées.',
        },
      },
    },
    
    // Solutions
    solutions: {
      title: 'Solutions et Services',
      subtitle: 'Solutions complètes de chaîne d\'approvisionnement de construction conçues pour les projets de construction modernes.',
      learnMore: 'En savoir plus',
      importExport: {
        title: 'Importation et Exportation',
        subtitle: 'Matériaux de Construction',
        description: 'Béton, verre, structures métalliques, isolation et éléments d\'ingénierie provenant de fabricants certifiés à travers l\'Europe.',
        features: {
          certification: 'Certification Qualité',
          compliance: 'Conformité UE',
          bulk: 'Commandes en Gros',
        },
      },
      distribution: {
        title: 'Distribution',
        subtitle: 'Électrique et Plomberie',
        description: 'Éclairage, câbles, ventilation, systèmes de chauffage avec solutions logistiques et de livraison complètes.',
        features: {
          delivery: 'Livraison Rapide',
          inventory: 'Gestion des Stocks',
          support: 'Support Technique',
        },
      },
      b2bPlatform: {
        title: 'Plateforme B2B',
        subtitle: 'Marché Numérique',
        description: 'Place de marché en ligne avec catalogue, tarification, logistique et gestion d\'applications pour des opérations fluides.',
        features: {
          pricing: 'Tarification en Temps Réel',
          tracking: 'Suivi des Commandes',
          documentation: 'Documentation Numérique',
        },
      },
      logistics: {
        title: 'Gestion Logistique',
        subtitle: 'Chaîne d\'Approvisionnement Complète',
        description: 'Gestion des douanes, certifications, transport et assurance pour des opérations simplifiées.',
        features: {
          customs: 'Dédouanement',
          insurance: 'Couverture d\'Assurance',
          tracking: 'Suivi de Bout en Bout',
        },
      },
      smartBuilding: {
        title: 'Solutions de Bâtiment Intelligent',
        subtitle: 'IA et Analyse de Données',
        description: 'Analyses d\'approvisionnement, optimisation budgétaire et solutions de construction durables alimentées par l\'intelligence artificielle.',
        features: {
          analytics: 'Analyses Prédictives',
          optimization: 'Optimisation des Coûts',
          sustainability: 'Indicateurs de Durabilité',
        },
      },
    },
    
    // Materials
    materials: {
      title: 'Catalogue de Matériaux',
      subtitle: 'Explorez notre catalogue complet de matériaux de construction premium provenant de fabricants européens certifiés.',
      searchPlaceholder: 'Rechercher des matériaux...',
      category: 'Catégorie',
      country: 'Pays',
      inStockOnly: 'En Stock Seulement',
      showing: 'Affichage',
      of: 'de',
      materials: 'matériaux',
      inStock: 'En Stock',
      outOfStock: 'Rupture de Stock',
      requestQuote: 'Demander un Devis',
      notifyWhenAvailable: 'M\'avertir quand Disponible',
      noMaterialsFound: 'Aucun matériau trouvé',
      tryAdjusting: 'Essayez d\'ajuster vos critères de recherche ou filtres.',
    },
    
    // Partners
    partners: {
      title: 'Partenaires et Clients',
      subtitle: 'Approuvé par les principales entreprises de construction et fabricants à travers l\'Europe.',
      certifiedPartners: 'Partenaires Certifiés',
      clientTestimonials: 'Témoignages Clients',
      stats: {
        projectsCompleted: 'Projets Terminés',
        partnerCompanies: 'Entreprises Partenaires',
        countriesServed: 'Pays Desservis',
        materialsCatalog: 'Catalogue de Matériaux',
      },
    },
    
    // Contact
    contact: {
      title: 'Lancez Votre Projet',
      subtitle: 'Prêt à transformer votre projet de construction? Contactez nos experts pour des solutions personnalisées.',
      projectInquiryForm: 'Formulaire de Demande de Projet',
      formDescription: 'Parlez-nous de vos exigences de projet et nous vous fournirons un devis personnalisé.',
      fullName: 'Nom Complet',
      emailAddress: 'Adresse Email',
      companyName: 'Nom de l\'Entreprise',
      phoneNumber: 'Numéro de Téléphone',
      projectType: 'Type de Projet',
      budgetRange: 'Gamme de Budget',
      projectDetails: 'Détails du Projet',
      selectProjectType: 'Sélectionner le type de projet',
      selectBudgetRange: 'Sélectionner la gamme de budget',
      describeProject: 'Veuillez décrire vos exigences de projet, calendrier et matériaux spécifiques nécessaires...',
      sendProjectInquiry: 'Envoyer la Demande de Projet',
      submitting: 'Envoi en cours...',
      contactInformation: 'Informations de Contact',
      address: 'Adresse',
      email: 'Email',
      businessHours: 'Heures d\'Ouverture',
      quickResponseGuarantee: 'Garantie de Réponse Rapide',
      quickResponseText: 'Nous répondons à toutes les demandes de projet dans les 24 heures. Pour les demandes urgentes, appelez-nous directement.',
      ourServices: 'Nos Services',
      projectTypes: {
        residential: 'Construction Résidentielle',
        commercial: 'Bâtiment Commercial',
        industrial: 'Installation Industrielle',
        infrastructure: 'Projet d\'Infrastructure',
        renovation: 'Rénovation/Modernisation',
        other: 'Autre',
      },
      budgetRanges: {
        under50k: 'Moins de 50 000 €',
        range50k250k: '50 000 € - 250 000 €',
        range250k1m: '250 000 € - 1 000 000 €',
        range1m5m: '1 000 000 € - 5 000 000 €',
        over5m: 'Plus de 5 000 000 €',
      },
      successMessage: 'Merci! Nous vous contacterons dans les 24 heures.',
      successDescription: 'Votre demande de projet a été reçue avec succès.',
    },
    
    // Footer
    footer: {
      description: 'Plateforme internationale premium pour les matériaux de construction et les solutions d\'ingénierie. Connectant fabricants, distributeurs et entreprises de construction à travers l\'Europe.',
      solutions: {
        title: 'Solutions',
        importExport: 'Importation et Exportation',
        distribution: 'Distribution',
        b2bPlatform: 'Plateforme B2B',
        logisticsManagement: 'Gestion Logistique',
        smartBuilding: 'Solutions de Bâtiment Intelligent',
      },
      materials: {
        title: 'Matériaux',
        steelMetal: 'Acier et Métal',
        concreteBlocks: 'Béton et Blocs',
        insulation: 'Isolation',
        glassFacades: 'Verre et Façades',
        electricalSystems: 'Systèmes Électriques',
      },
      company: {
        title: 'Entreprise',
        aboutUs: 'À Propos de Nous',
        ourPartners: 'Nos Partenaires',
        qualityStandards: 'Normes de Qualité',
        sustainability: 'Durabilité',
        careers: 'Carrières',
      },
      support: {
        title: 'Support',
        contactUs: 'Nous Contacter',
        technicalSupport: 'Support Technique',
        documentation: 'Documentation',
        faq: 'FAQ',
        termsConditions: 'Termes et Conditions',
      },
      copyright: '© 2025 PROBUILD MARKET LIMITED. Tous droits réservés.',
      privacyPolicy: 'Politique de Confidentialité',
      cookiePolicy: 'Politique des Cookies',
      legalNotice: 'Avis Légal',
      followUs: 'Suivez-nous:',
    },
    
    // Modals
    modals: {
      quote: {
        title: 'Obtenir un Devis Instantané',
        description: 'Parlez-nous de vos besoins en matériaux de construction et recevez un devis détaillé dans les heures qui suivent.',
        cancel: 'Annuler',
        sending: 'Envoi en cours...',
        getQuote: 'Obtenir un Devis',
        projectTypes: {
          steelMetal: 'Structures Acier et Métal',
          concrete: 'Béton et Maçonnerie',
          insulation: 'Matériaux d\'Isolation',
          electrical: 'Systèmes Électriques',
          plumbing: 'Plomberie et CVC',
          glass: 'Verre et Façades',
          mixed: 'Projet Matériaux Mixtes',
        },
        budgetRanges: {
          under25k: 'Moins de 25 000 €',
          range25k100k: '25 000 € - 100 000 €',
          range100k500k: '100 000 € - 500 000 €',
          range500k2m: '500 000 € - 2 000 000 €',
          over2m: 'Plus de 2 000 000 €',
        },
        urgency: {
          immediate: 'Immédiat (Dans 1 semaine)',
          urgent: 'Urgent (Dans 1 mois)',
          standard: 'Standard (1-3 mois)',
          planning: 'Phase de Planification (3+ mois)',
        },
        successMessage: 'Demande de devis envoyée avec succès!',
        successDescription: 'Notre équipe vous contactera dans les 4 heures avec un devis détaillé.',
      },
      materialQuote: {
        requestQuote: 'Demander un Devis',
        quantityRequired: 'Quantité Requise',
        requiredDeliveryDate: 'Date de Livraison Requise',
        deliveryAddress: 'Adresse de Livraison',
        specialRequirements: 'Exigences Spéciales',
        units: 'unités',
        estimatedTotal: 'Total Estimé',
        finalPriceNote: '*Le prix final peut varier en fonction des taux du marché actuels et de l\'emplacement de livraison',
        successMessage: 'Demande de devis matériau envoyée!',
      },
      demo: {
        title: 'Démo de la Plateforme PROBUILD MARKET',
        description: 'Explorez notre plateforme de matériaux de construction et voyez comment elle peut transformer vos projets de construction.',
        demoSections: 'Sections de Démo',
        readyToStart: 'Prêt à commencer?',
        readyDescription: 'Obtenez une démo personnalisée avec nos experts en matériaux de construction.',
        scheduleLiveDemo: 'Programmer une Démo en Direct',
        overview: {
          title: 'Vue d\'Ensemble PROBUILD MARKET',
          description: 'Découvrez comment notre plateforme connecte les fournisseurs européens de matériaux de construction avec les constructeurs',
        },
        materials: {
          title: 'Entrepôt de Matériaux',
          description: 'Explorez notre vaste inventaire de matériaux de construction certifiés provenant de plus de 150 fournisseurs',
        },
        ordering: {
          title: 'Système de Commande B2B',
          description: 'Processus d\'approvisionnement numérique du devis à la livraison avec logistique en temps réel',
        },
        tracking: {
          title: 'Suivi de la Chaîne d\'Approvisionnement',
          description: 'Surveillez les matériaux des entrepôts européens à votre chantier',
        },
      },
    },
    
    // Pages
    pages: {
      importExport: {
        backToHome: 'Retour à l\'Accueil',
        badge: 'Solutions d\'Importation et d\'Exportation',
        title: 'Matériaux de Construction Premium',
        titleFrom: 'De Toute l\'Europe',
        description: 'Accédez à des matériaux de construction certifiés provenant de plus de 150 fabricants européens. Nous gérons tout, de l\'approvisionnement à la livraison, garantissant qualité et conformité.',
        requestMaterialsQuote: 'Demander un Devis de Matériaux',
        viewCatalog: 'Voir le Catalogue',
        materialCategories: 'Catégories de Matériaux',
        whyChoose: 'Pourquoi Choisir Nos Services d\'Importation/Exportation',
        ourImportProcess: 'Notre Processus d\'Importation',
        readyToSource: 'Prêt à S\'approvisionner en Matériaux Premium?',
        contactExperts: 'Contactez nos experts en matériaux pour des solutions d\'approvisionnement personnalisées.',
        getStartedToday: 'Commencer Aujourd\'hui',
      },
    },
    
    // Common
    common: {
      required: 'requis',
      selectType: 'Sélectionner le type',
      selectTimeline: 'Calendrier',
      urgency: 'Urgence',
      placeholder: {
        enterFullName: 'Entrez votre nom complet',
        enterEmail: 'votre.email@entreprise.com',
        enterCompany: 'Votre Entreprise Ltd.',
        enterPhone: '+33 XX XX XX XX',
        enterAddress: 'Adresse de livraison complète incluant le code postal...',
        enterRequirements: 'Toute manipulation spéciale, spécifications personnalisées ou instructions de livraison...',
        describeRequirements: 'Veuillez décrire vos exigences spécifiques en matériaux, quantités, calendrier de livraison et spécifications spéciales...',
      },
    },
  },
};

